<article
  class="promotion-card"
  [class.promotion-card--participating]="variant() === 'participating'"
  [class.promotion-card--past]="variant() === 'past'"
  [class.promotion-card--link]="isCardLink()"
  [attr.role]="isCardLink() ? 'link' : null"
  [attr.tabindex]="isCardLink() ? 0 : null"
  (click)="openPromotionDetails()"
  (keydown)="onCardKeydown($event)"
>
  <div class="promotion-card__image">
    @if (variant() === 'featured') {
      <span class="promotion-card__image-mark" aria-hidden="true"></span>
    }
    @if (promotion().image) {
      <img [src]="promotion().image" [alt]="promotion().title" />
    } @else {
      <img class="promotion-card__placeholder" src="assets/img/promotions/promotion-placeholder.svg" alt="UniGana" />
    }
  </div>

  @if (variant() !== 'past' && timeRemainingLabel()) {
    <div class="promotion-card__time">
      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true">
        <path
          d="M8 3.33333C5.42267 3.33333 3.33333 5.42267 3.33333 8C3.33333 10.5773 5.42267 12.6667 8 12.6667C10.5773 12.6667 12.6667 10.5773 12.6667 8C12.6667 5.42267 10.5773 3.33333 8 3.33333ZM8 2C11.3137 2 14 4.68629 14 8C14 11.3137 11.3137 14 8 14C4.68629 14 2 11.3137 2 8C2 4.68629 4.68629 2 8 2ZM8.66667 4.66667V7.72386L10.4714 9.5286L9.5286 10.4714L7.33333 8.27614V4.66667H8.66667ZM6 0.666667H10V2H6V0.666667Z"
          fill="#FCFCFC"
        />
      </svg>
      <span>{{ timeRemainingLabel() }}</span>
    </div>
  }

  <div class="promotion-card__content">
    @if (variant() === 'past' && promotion().end_date) {
      <time class="promotion-card__date" [attr.datetime]="promotion().end_date">
        {{ promotion().end_date | date: 'd MMM yy' }}
      </time>
    }

    <div class="promotion-card__copy">
      <h2>{{ promotion().title }}</h2>
      @if (promotion().description) {
        <p>{{ promotion().description }}</p>
      }
    </div>

    @if (variant() !== 'past') {
      <div class="promotion-card__tags">
        <app-tag type="success">{{ availableEntriesLabel() }}</app-tag>
        @if (appliedEntriesLabel()) {
          <app-tag type="info">{{ appliedEntriesLabel() }}</app-tag>
        }
        @if (statusLabelKey()) {
          <app-tag type="info">{{ statusLabelKey() | translate }}</app-tag>
        }
      </div>
    }

    @if (variant() === 'participating' && (topRewardLabel() || objectiveLabel() || claimStatusLabelKey())) {
      <dl class="promotion-card__metadata">
        @if (topRewardLabel()) {
          <div>
            <dt>{{ 'promotions.campaignDetails.topReward' | translate }}</dt>
            <dd>{{ topRewardLabel() }}</dd>
          </div>
        }
        @if (objectiveLabel()) {
          <div>
            <dt>{{ 'promotions.campaignDetails.objective' | translate }}</dt>
            <dd>{{ objectiveLabel() }}</dd>
          </div>
        }
        @if (claimStatusLabelKey()) {
          <div>
            <dt>{{ 'promotions.campaignDetails.claimStatus' | translate }}</dt>
            <dd>{{ claimStatusLabelKey() | translate }}</dd>
          </div>
        }
      </dl>
    }
  </div>

  @if (variant() === 'featured') {
    <div class="promotion-card__actions">
      <korviu-button
        class="promotion-card__button"
        size="small"
        type="link"
        [link]="'/workspace/promotions/' + promotion().id"
      >
        <span linkText>{{ 'promotions.getMoreEntries' | translate }}</span>
      </korviu-button>
      <div class="promotion-card__tickets">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="21"
          height="21"
          viewBox="0 0 21 21"
          fill="none"
          aria-hidden="true"
        >
          <path
            d="M12.5247 1.70143C12.2349 1.41164 11.7651 1.41164 11.4753 1.70143L1.70142 11.4753C1.41164 11.7651 1.41164 12.2349 1.70142 12.5247L2.75831 13.5816C3.15132 13.3618 3.60442 13.2368 4.0847 13.2368C5.58737 13.2368 6.80553 14.4549 6.80553 15.9576C6.80553 16.438 6.68046 16.891 6.46073 17.284L7.51774 18.3411C7.80753 18.6308 8.27736 18.6308 8.56715 18.3411L18.3411 8.56715C18.6308 8.27736 18.6308 7.80754 18.3411 7.51775L17.2841 6.4608C16.891 6.68063 16.4378 6.80577 15.9574 6.80577C14.4547 6.80577 13.2366 5.58761 13.2366 4.08494C13.2366 3.60454 13.3617 3.15132 13.5816 2.75824L12.5247 1.70143ZM10.4259 0.652019C11.2953 -0.21734 12.7048 -0.21734 13.5742 0.652019L14.7331 1.81107C15.2385 2.3164 15.148 3.02578 14.8931 3.45434C14.7837 3.63841 14.7207 3.85317 14.7207 4.08494C14.7207 4.76798 15.2743 5.32168 15.9574 5.32168C16.1891 5.32168 16.4039 5.25864 16.5879 5.14919C17.0166 4.89438 17.7259 4.80382 18.2312 5.30916L19.3904 6.46833C20.2598 7.3377 20.2598 8.74722 19.3904 9.6166L9.6166 19.3904C8.74722 20.2598 7.33769 20.2598 6.46833 19.3904L5.3091 18.2312C4.80383 17.7259 4.89429 17.0167 5.14903 16.5881C5.25841 16.404 5.32144 16.1893 5.32144 15.9576C5.32144 15.2746 4.76773 14.7209 4.0847 14.7209C3.85299 14.7209 3.63827 14.7839 3.45424 14.8933C3.02567 15.1481 2.3164 15.2385 1.81113 14.7332L0.652015 13.5742C-0.217343 12.7048 -0.217333 11.2953 0.652015 10.4259L10.4259 0.652019Z"
            fill="#505760"
          />
        </svg>
        <span>{{ ticketsLabel() }}</span>
      </div>
    </div>
  }
</article>
